// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu_wrapper__pkwZf","menu":"menu_menu__5219y","heading":"menu_heading__m1R6E","secondary":"menu_secondary__Q3vLp"};